// extracted by mini-css-extract-plugin
module.exports = {"displayMarkDownCodeContainer":"_31imb","copy-code-container":"gmMzy","copyCodeContainer":"gmMzy","language":"_2r5bx"};